import React, { useEffect, useState } from 'react'
import FmsDashboardMainRoot from '../FmsDashboardMainRoot'
import { BoldText1, SmallText } from '../../../helpers/constants/ConstantsText'
import PrimaryButton, { SecondaryButton } from '../../../components/buttons/PrimaryButton'
import { Drawer, Input,Pagination, Button,Upload,Select } from 'antd'
import { IoIosClose } from 'react-icons/io';
import { theme_color } from '../../../helpers/constants/ConstantColor'
import {AiOutlineInfoCircle} from 'react-icons/ai'
import axios from 'axios'
import { authHeader } from '../../../helpers/usertoken/UserToken'
import { useLocation } from 'react-router-dom'
import { Toaster, toast } from 'react-hot-toast'
import { Col, Row } from 'antd';
import moment from 'moment';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { base_url, local_base_url } from '../../../App'
import FileDownload from 'js-file-download';
import TextArea from 'antd/lib/input/TextArea'
import { CloseOutlined, UploadOutlined } from '@mui/icons-material';


function FmsClientsAttachments() {

  const {state} = useLocation()
  

  const [modal,setmodal] = useState(false)
  const [data,setdata] = useState({type:'',type1:'',file:'',expiry_date:'',remarks:''})
  const [error,seterror] = useState({type:'',type1:'',file:'',expiry_date:'',remarks:''})
  const [datas,setdatas] = useState([])
  const [selectedChecklist,setselectedcheckList] = useState([])
  const [checkList,setcheckList] = useState([])
  const [pagination,setpagination] = useState({})
  const [page,setpage] = useState(1)


  const typeArr = [
    {label:'Agreement',value:'Agreement'},
    {label:'Commercial',value:'Commercial'},
    {label:'Other',value:'Other'},
  ]

  useEffect(()=>{
    getData()
  },[page])


  function getData(){
    axios.get(`fms/client_attachment/get/${state._id}?page=${page}`,authHeader).then((res)=>{
            setpagination(res.data.pagination)
            setdatas(res.data.datas)
            }).catch((err)=>{
            })
  }

  function setpagefuun(v){
    setpage(v)
  }

  function submitform(){
    if(!data.type){
        seterror({...error,type:'This Field is required*'})
    }else if(data.type == 'Other' && !data.type1){
      seterror({...error,type1:'This Field is required*'})
    }else if(!data.file){
        seterror({...error,file:'This Field is required*'})
    }else{
      
       authHeader['headers']['Content-Type'] = 'application/json'
        let send_Data = {...data}
        send_Data['client'] = state._id
       
        if(data?.id === null || data?.id === undefined){
         axios.post(`fms/client_attachment/create`,send_Data,authHeader).then((res)=>{
            if(res.status === 201){
                toast.success("Created Successfully!")
                setdata({type:'',file:'',expiry_date:'',remarks:''})
                seterror({type:'',file:'',expiry_date:'',remarks:''})
                setmodal(false)
                getData()
            }
            }).catch((err)=>{
            })
        } else{
            axios.put(`fms/client_attachment/update/${data?.id}`,send_Data,authHeader).then((res)=>{
                if(res.status === 200){
                    toast.success("Updated Successfully!")
                    setdata({type:'',file:'',expiry_date:'',remarks:''})
                    seterror({type:'',file:'',expiry_date:'',remarks:''})
                    setmodal(false)
                    getData()
                }
                }).catch((err)=>{
                })
        }  
    }
  }



  function deletedata(id){
    axios.delete(`fms/client_attachment/delete/${id}`,authHeader).then((res)=>{

        if(res.status === 200){
            toast.success(res?.data?.message)
            getData()
            setmodal(false)
        }
        }).catch((err)=>{
        })
  }


  function uploadFile(name,v){
          
    authHeader['headers']['Content-Type'] = 'multipart/form-data'
           var fd = new FormData()
           fd.append('file',v?.fileList[v?.fileList.length - 1]?.originFileObj)
           axios.post(`fms/basicemployee/upload_file`,fd,authHeader)
           .then((res)=>{
               if(name === 'file'){
                   setdata({...data,file:res?.data?.data})
                   seterror({...error,file:''})
               }
              
           }).catch((err)=>{
               console.log("err data",err)
           })
  }
  
  function openfile(v){
    let url = `${base_url}` + v
    window.open(url,'_blank')
  }

 
  return (
    <FmsDashboardMainRoot>
        <Toaster/>
        <Drawer visible={modal} footer={false} closable={false} maskClosable={true}>
            <div style={{position:'relative',overflowY:'scroll'}}>
            <IoIosClose  onClick={() => setmodal(false)}size={20} style={{position:'absolute',top:'-20px',cursor:'pointer',right:'-10px'}} />
                <h6 style={{background:'#eee',padding:'4px',fontSize:'11px',fontWeight:'400',marginTop:'10px'}}>Use the below form to create or update the client attachments</h6>


                <div style={{display:'flex',flexDirection:'column',flexWrap:'wrap',marginTop:'5px'}}>
                <SmallText fontWeight={'600'} val={'Type'}  />
                <Select 
                  value={data?.type}
                  onChange={(v)=>{setdata({...data,type:v});seterror({...error,type:''})}}
                  options={typeArr}
                  style={{borderLeft:`4px solid ${theme_color}`,}}
                />
                </div>
                
                {data?.type == 'Other' &&
                <div style={{marginTop:'10px'}}>
                <div style={{width:'150px'}}>
                <SmallText fontWeight={'600'} val={'Type'}  />
                </div>
                <Input type="text" style={{borderLeft:`4px solid ${theme_color}`}}  value={data.type1} onChange={(e)=>{setdata({...data,type1:e.target.value});seterror({...error,type1:''})}} />
                </div>}

                <div style={{display:'flex',flexDirection:'row !important'}}>
                {(error?.type1) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
                <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.type1}</p>
                </div>

                <div style={{display:'flex',flexDirection:'row !important'}}>
                {(error?.type) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
                <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.type}</p>
                </div>


                <div style={{width:'250px',position:'relative',margin:'10px 0px'}}>
                    <div style={{width:'150px'}}>
                    <SmallText fontWeight={'600'} val={'Image'} />
                    {!(data.file === null || data.file == undefined || data.file == '') && <h6 onClick={()=>openfile(data.file)} style={{color:'#3f9ae0',textDecoration:'underline',fontSize:'12px',position:'absolute',right:'-40px',top:'0px',cursor:'pointer'}}>View File</h6>}
                    </div>
                    {(data.file === null || data.file == undefined || data.file == '') ?
                    <Upload showUploadList={false} onChange={(v)=> uploadFile('file',v)} style={{borderLeft:`4px solid ${theme_color}`,width:'200px'}} >
                        <Button style={{borderLeft:`4px solid ${theme_color}`,width:'325px',display:'flex',alignSelf:'flex-end',justifyContent:'end'}} icon={<UploadOutlined   style={{borderLeft:'1px solid #eee',color:'#999',paddingLeft:'0px'}}/>}></Button>
                    </Upload>
                    :
                    <Button  onClick={()=>{setdata({...data,file:null});seterror({...error,file:''})}} style={{borderLeft:`4px solid ${theme_color}`,width:'325px',display:'flex',alignItems:'left',fontSize:'10px',marginBottom:'0px'}} ><p style={{marginBottom:'0px', wordBreak: 'break-word',whiteSpace:'nowrap',width:'90%',overflow:'hidden',textOverflow:'ellipsis',marginLeft:'0px',textAlign:'left',marginBottom:'0px'}}>{data.file?.name != undefined ? data.file?.name : data?.file?.split('/')[data?.file?.split('/').length-1] }</p> {<CloseOutlined size={15}  style={{borderLeft:'1px solid #eee',color:'#999',paddingLeft:'0px',position:'absolute',right:'0px'}}/>}</Button>
                    }
                   </div>  

                  <div style={{display:'flex',flexDirection:'row !important'}}>
                  {(error?.file) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
                  <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.file}</p>
                  </div>
 

                <div style={{marginBottom:'10px'}}>
                <div style={{width:'150px'}}>
                <SmallText fontWeight={'600'} val={'Remarks '}  />
                </div>
                <TextArea type="text"  value={data.remarks} onChange={(e)=>{setdata({...data,remarks:e.target.value});seterror({...error,remarks:''})}} />
                </div>

                <div style={{display:'flex',flexDirection:'row !important'}}>
                {(error?.remarks) &&  
                <span style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}><AiOutlineInfoCircle size={14} style={{color:'red'}}/> {error?.remarks}</span>}
                </div>


                <div style={{marginBottom:'10px'}}>
                <div style={{width:'150px'}}>
                <SmallText fontWeight={'600'} val={'Expiry Date '}  />
                </div>
                <Input type="date"  value={data.expiry_date} onChange={(e)=>{setdata({...data,expiry_date:e.target.value});seterror({...error,expiry_date:''})}} />
                </div>

                <div style={{display:'flex',flexDirection:'row !important'}}>
                {(error?.expiry_date) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
                <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.expiry_date}</p>
                </div>


                <div style={{display:'flex'}}>
                    <PrimaryButton btn_name={'Save'} onClick={submitform}/>
                    <SecondaryButton btn_name={'Close'} onClick={()=>setmodal(false)}/>
                </div>


            </div>

        </Drawer>
     
        <div style={{width:'98%'}}>
            <div style={{borderBottom:'1px solid #ddd',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
            <BoldText1 val={`Clients Attachments (${pagination?.total})`} />

            <PrimaryButton btn_name={'Add Client Docs'} onClick={()=>setmodal(true)} />
            </div>

            <Row style={{marginTop:'5px'}}>
            {datas?.map((d)=>(
              <Col span={6}>
                <div style={{border:'1px solid #eee',padding:'6px 12px',width:'98%',margin:'1%',position:'relative'}}>
                    <span style={{position:'absolute',right:'5px',top:'0px'}}><AiOutlineDelete onClick={()=>deletedata(d?._id)} size={12}  style={{marginRight:'4px'}} /> <AiOutlineEdit onClick={()=>{setdata({...data,...d,id:d?._id,});;setmodal(true)}} size={12}  style={{marginRight:'4px'}} /></span>
                    <h6 style={{fontSize:'11px',marginBottom:'2px'}}>Type : <span style={{fontWeight:'700'}}>{d?.type}</span></h6>
                    <h6 style={{fontSize:'11px'}}>Expiry Date : <span style={{fontWeight:'700'}}>{moment(d?.expiry_date)?.format('LL')} </span></h6>
                    <h6 style={{fontSize:'11px'}}>Created By : <span style={{fontWeight:'700'}}>{d?.created_by?.name} </span></h6>
                    
                    <h6 style={{fontSize:'11px'}}>
                    {!(d?.file === null || d?.file == undefined || d?.file == '') && <h6 onClick={()=>openfile(d?.file)} style={{color:'#3f9ae0',textDecoration:'underline',fontSize:'12px',cursor:'pointer'}}>View File</h6>}


                    </h6>
                    <h6 style={{fontSize:'11px'}}>Remarks : <span style={{fontWeight:'700'}}>{d?.remarks}</span></h6>
                    <h6 style={{fontSize:'10px',background:'#f2f2f2',padding:'4px'}}>Created At : <span style={{fontWeight:'700'}}>{moment(d?.createdAt)?.format('LLL')}</span></h6>
                </div>
              </Col>
            ))}
            </Row>

            <div style={{ minWidth: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
                {pagination.total > pagination?.limit &&
                    <Pagination current={page} size="small" total={pagination.total} onChange={(v) => setpagefuun(v)}  pageSize={15} />
                }
            </div>
        </div>

    </FmsDashboardMainRoot>
  )
}

export default FmsClientsAttachments